import React from 'react';

import type Trip from '@this/domain/trip/trip2';
import { styled } from '@this/src/components/constants/themes';
import { getSpacing } from '@this/src/components/shared/ui/theme';
import { Box } from '@material-ui/core';
import { OrganizationAsideButtons } from './organization_aside_buttons';

interface Props {
  trip: Trip;
  planName: string;
}
export const PartnerDescription: React.FC<Props> = ({ trip, planName }) => {
  const organizationId = trip?.organization?.id;

  return (
    <div>
      <Section>
        <Box display="flex" justifyContent="space-between">
          <div>
            <SectionTitle>料金プラン</SectionTitle>
            <p>{planName}</p>
          </div>
          {organizationId && (
            <Section>
              <OrganizationAsideButtons organizationId={organizationId} />
            </Section>
          )}
        </Box>
      </Section>
    </div>
  );
};

const Section = styled.section`
  & + & {
    margin-top: ${getSpacing(4)}px;
  }
`;

const SectionTitle = styled.h3`
  margin-bottom: ${getSpacing(1)}px;
`;
